module.exports = __webpack_public_path__ + "static/media/maxar_logo.9175ca78.png";